import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { Edit } from "@mui/icons-material";
import Service from "../../../util/Service";
import KanBanRootV2 from "./KanBanRootV2";
import { useProfile } from "../../common/useProfile";

export default function KanbanRootView() {
    const params = useParams();
    const navigate = useNavigate();
    const prof = useProfile();
    const [kanban, setKanban] = React.useState();

    React.useEffect(() => {
        buscaProjeto();
    }, [])
    function buscaProjeto() {
        // const id = params.id;
        const idKanban = params.idKanban;
        Service.GET("/api/projeto/kanban/" + idKanban).then(r => {
            console.log(r)
            setKanban(r);
        });
    }
    
    if (!kanban) {
        return (
            <p>Aguarde....</p>
        )
    }
    return (
        <div >
            <div >
                {prof.temAcesso("ProjectAdm") && 
                <div 
                    style={{ float: "left", marginLeft: '0px' }} 
                >
                <Tooltip title="Ir para edição do kanban">
                    <IconButton aria-label="edit" color="primary"
                        onClick={() => navigate('/project/kanban/' + kanban.idProjeto + "/" + kanban.id, { state: {} })}
                    >
                        <Edit />
                    </IconButton>
                </Tooltip>
                </div>}
                {kanban &&
                    <Typography variant="h4" component="h2" style={{ textAlign: "center" }}>
                        {kanban.nome}
                    </Typography>}
            </div>
            <div 
                style={{
                    padding: '2px',
                    fontSize: '14px',
                    overflow: 'auto',
                    maxHeight:'620px',
                    width: '100%',
                }}
            >
                <Stack sx={{ mt: 2 }}>
                    <KanBanRootV2 />
                </Stack>
            </div>
        </div>
    )
}